import { AudioContextClock } from './AudioContextClock';
export class AudioBufferClock extends AudioContextClock {
    audioBuffer;
    player;
    constructor(audioContext, audioBuffer) {
        super(audioContext);
        this.audioBuffer = audioBuffer;
        this.player = null;
    }
    close() {
        this.stopPlayer();
    }
    async _seek(time) {
        this.stopPlayer();
        await super._seek(time);
        if (this.audioContext.state == 'running') {
            this.startPlayer();
        }
        return this.now;
    }
    async _pause() {
        this.stopPlayer();
        return super._pause();
    }
    get duration() {
        return this.audioBuffer.duration;
    }
    async _end() {
        this.stopPlayer();
        return super._end();
    }
    async _resume() {
        this.startPlayer();
        return super._resume();
    }
    startPlayer = () => {
        this.stopPlayer();
        this.player = new AudioBufferPlayer(this.audioContext, this.audioBuffer, this.now);
    };
    stopPlayer = () => {
        this.player?.stop();
        this.player = null;
    };
    static async fromUrl(url, audioContext, init) {
        const audioBuffer = await loadAudioBuffer(url, audioContext, init);
        return new AudioBufferClock(audioContext, audioBuffer);
    }
}
class AudioBufferPlayer {
    audioContext;
    audioBuffer;
    position;
    _source;
    _offset;
    _running;
    constructor(audioContext, audioBuffer, position) {
        this.audioContext = audioContext;
        this.audioBuffer = audioBuffer;
        this.position = position;
        this._source = audioContext.createBufferSource();
        this._source.buffer = audioBuffer;
        this._source.connect(audioContext.destination);
        const currentTime = this.audioContext.currentTime;
        this._offset = currentTime - this.position;
        this._source.start(currentTime, this.position);
        this._running = true;
        this._source.addEventListener('ended', this.endListener, { once: true });
    }
    endListener = (e) => {
        this._running = false;
    };
    get now() {
        return this.audioContext.currentTime - this._offset;
    }
    get running() {
        return this._running;
    }
    stop = () => {
        this._source.removeEventListener('ended', this.endListener);
        this._source.stop();
        this._source.disconnect();
        this._running = false;
    };
}
export async function loadAudioBuffer(url, audioContext, init) {
    const response = await fetch(url, init);
    if (response.ok || init?.mode === 'no-cors') {
        const arrayBuffer = await response.arrayBuffer().catch(e => {
            throw new Error(`Failed to read array buffer from ${url}`);
        });
        if (arrayBuffer.byteLength == 0) {
            throw new Error(`Failed to decode audio file from ${url}: empty file`);
        }
        return audioContext.decodeAudioData(arrayBuffer).catch(e => {
            throw new Error(`Failed to decode audio file from ${url}: ${e}`);
        });
    }
    else {
        throw new Error(`Failed to load audio file from ${url}. ${response.status}: ${response.statusText}`);
    }
}
//# sourceMappingURL=AudioBufferClock.js.map